import React from 'react';
import {observer} from "mobx-react";
import {withStore} from "../../hocs";
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import {WIDTH} from "../../const/root";

// @ts-ignore
@withStore
@observer
export class SearchTopForm extends React.Component {
    private inputEl: HTMLInputElement | null = null;
    private debounceTimer: any = null;

    componentDidMount() {}

    componentDidUpdate(prevProps: any) {
        const prevSearch = prevProps?.store?.pageCatalogStore?.search ?? '';
        const nextSearch = (this.props as any)?.store?.pageCatalogStore?.search ?? '';

        // Синхронизируем DOM-value если стор поменял search извне (например, через очистку).
        if (prevSearch !== nextSearch && this.inputEl && this.inputEl.value !== nextSearch) {
            this.inputEl.value = nextSearch;
        }
    }

    // @ts-ignore
    addDefaultSrc = ev => {
        ev.target.src = '/img/no-image.webp'
    }

    render() {
        // @ts-ignore
        const {store} = this.props;
        const {onChangeInput, onClickSearchButton2, onClearAndRemoveSearchInput} = store?.pageCatalogStore;
        let Width = window.innerWidth
        return (
            <>
                <Paper
                    elevation={0}
                    style={{ borderRadius: '20px', background: "#f0f2f6", margin: "auto" , }}
                    sx={Width < WIDTH ?{ p: '0px 4px', display: 'flex',  width: 320 } : { p: '0px 4px', display: 'flex',  width: 250 }}
                >
                    <IconButton onClick={onClickSearchButton2}  sx={{ p: '10px' }} aria-label="search">
                        <SearchIcon style={{color: '#b17882'}}/>
                    </IconButton>
                    <InputBase
                        onKeyPress={(e) => {
                            if (e.key === "Enter") {
                                const value = (e.target as HTMLInputElement)?.value ?? '';
                                if (this.debounceTimer) clearTimeout(this.debounceTimer);
                                onChangeInput({ target: { value } });
                                onClickSearchButton2();
                            }
                        }}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (this.debounceTimer) clearTimeout(this.debounceTimer);
                            this.debounceTimer = setTimeout(() => {
                                onChangeInput({ target: { value } });
                            }, 250);
                        }}
                        inputRef={(el: any) => {
                            this.inputEl = el;
                        }}
                        name="q" id="search__field--top"
                        sx={{ ml: 1, flex: 1 }}
                        placeholder="Поиск"
                        style={{fontStyle: 'italic', color: "#000000" }}
                        autoComplete= "off"
                    />

                    <IconButton onClick={onClearAndRemoveSearchInput} sx={{ p: '10px' }} aria-label="delete">
                        <ClearIcon style={{color: '#b17882'}} />
                    </IconButton>
                </Paper>
            </>
        );
    }
}

